import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "@/App";
import "./i18n";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@/pages/fonts.css";
import "@/theme.css";

async function prepareAndRender() {
  if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_MOCK_BACKEND === "true") {
    try {
      const { default: mswReady } = await import("./mocks/initMocks");
      await mswReady;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("Could not start MSW (local mocks):", err);
    }
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: true,
        retry: 1,
      },
    },
  });

  const container = document.getElementById("root");
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </React.StrictMode>,
    );
  }
}

if (process.env.NODE_ENV !== "test") {
  prepareAndRender();
}
